import getLocale from '../utils/getLocale';
import request from '../utils/request';
import { getItemFromPersistentStore } from '../utils/Persist';
import getCookieValue from '../utils/getCookieValue';
import isApiWhitelisted from '../utils/whitelistedApi';
import redirectToLogin from '../utils/redirectToLogin';
import defaultTranslations from '../Translations/en.json';
import { OYOOS_HOST, HTTP_REQUEST_HEADERS } from '../constants';
import getSourceClient from '../utils/getSourceClient';

const oyoOSMiddleware = props => {
    const { store, next, action, logoutAction, accessToken, shouldAvoidDefaultHost } = props;

    if (!action || !action.hmsFetchConfig) {
        return next(action);
    }

    const isLoggedIn = getItemFromPersistentStore('isLoggedIn', false) || getCookieValue('isLoggedIn') === 'true';

    if (!isLoggedIn && !isApiWhitelisted(action.hmsFetchConfig.path)) {
        redirectToLogin(store);
    }
    else {
        const hasMultilepleFetchConfig = Array.isArray(action.hmsFetchConfig);
        const fetchConfig = hasMultilepleFetchConfig ? action.hmsFetchConfig : [action.hmsFetchConfig];
        const storeState = store.getState();
        const selectedHotelId = storeState.dashboard.active_hotel_id;
        const promises = fetchConfig.map(config => {
            const queryParams = config.queryParams || {};
            const headers = {
                'httpxoyolang': getLocale(storeState.dashboard.language),
                'x-qid': selectedHotelId,
                [HTTP_REQUEST_HEADERS.X_SOURCE_CLIENT]: getSourceClient()
            };

            if (accessToken) {
                headers['hmaccesstoken'] = accessToken;
                /* adding 'xsigntype' because if we pass this key node server won't do any change with token
                and will pass it to the concerned service */
                headers['xsignintype'] = 'micro_front_end';
            }

            return request({
                host: config.host || (shouldAvoidDefaultHost ? OYOOS_HOST : undefined),
                urlParams: config.urlParams,
                path: config.path,
                body: config.body,
                method: config.method,
                isFile: config.isFile,
                isUploadToServer: config.isUploadToServer,
                additionalParams: config.additionalParams,
                headers: {
                    ...headers,
                    ...config.headers
                },
                queryParams: { qid: selectedHotelId, ...queryParams },
                onUploadProgress: config.onUploadProgress
            });
        });

        return Promise.all(promises)
            .then(responses => {
                action.onSuccess({
                    data: hasMultilepleFetchConfig ? responses : responses[0],
                    store,
                    next,
                    action
                });
            })
            .catch(error => {
                if (error.statusCode === 401) {
                    logoutAction && logoutAction({ store });
                    error.message = defaultTranslations.SESSION_EXPIRED;
                }
                action.onError({ error, store, action, next });
            });
    }
};

export default oyoOSMiddleware;